import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';
import { ThemeProvider } from 'styled-components';

import FlowFooter from '@ui/atoms/FlowFooter';
import FlowPageContainer from '@ui/atoms/FlowPageContainer';
import MembershipContainer from '@ui/atoms/MembershipContainer';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import NewFlowHeader from '@ui/organisms/NewFlowHeader';

import { keysToCamel } from '@utils/butter';

import { getThemeForFlow } from '@theme/FlowThemes';

import NextStepsStep, { INextStepsStepPageContent } from './NextStepsStep.component';

interface INextStepsStepPageProps {
	path: string;
}

const NextStepsStepPage: FC<INextStepsStepPageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "medication-next-steps" }) {
				page_header
				page_description
				get_care_label
				get_care_href
			}
		}
	`);

	const refinedContent: INextStepsStepPageContent = keysToCamel(
		pageContent
	) as INextStepsStepPageContent;

	return (
		<CenteredGridItem>
			<ThemeProvider theme={getThemeForFlow('dashboard')}>
				<FlowPageContainer
					header={<NewFlowHeader flowName="Estrogen" totalSteps={1} step={1} />}
					footer={<FlowFooter />}>
					<MembershipContainer>
						<NextStepsStep
							pageContent={refinedContent}
							path={path}
							stepKey="MED_PURCHASE_SUCCESS"
						/>
					</MembershipContainer>
				</FlowPageContainer>
			</ThemeProvider>
		</CenteredGridItem>
	);
};

export default NextStepsStepPage;
